module.exports = __webpack_public_path__ + "img/icon_city10.e17925a4.png";